import { ModerationOutcomes } from '../../components/reviews';
import { ContentContainer } from '../../components/ContentContainer';

export const ModerationOutcomesSection = () => {
  return (
    <ContentContainer>
      <div className="mb-4">
        <h2 className="text-xl font-semibold text-gray-900">Review Moderation Outcomes</h2>
        <p className="text-sm text-gray-600 mt-1">
          Track the status of reviews you have flagged for moderation.
        </p>
      </div>
      <ModerationOutcomes />
    </ContentContainer>
  );
};
